import React, { useState } from 'react';
import { CookieManager } from '../scripts/cookie-manager.js';

function DataDownload() {
    const [cookieManager] = useState(() => new CookieManager());

    const handleDownloadClick = (e) => {
        // If the gate hasn't been submitted or dismissed, prevent download and show modal.
        // Checked at click time: a dismissal earlier on this page clears the gate
        if (!cookieManager.isGateCleared()) {
            e.preventDefault();

            // Try to get the gating modal reference
            const gatingModal = window.gatingModal;

            if (gatingModal) {
                // Set up pending download for after form submission
                gatingModal.pendingDownload = {
                    href: '/data/fire_rankings_national_trends.csv',
                    download: 'fire_rankings_national_trends.csv',
                    type: 'trends'
                };

                // Show the gating modal
                gatingModal.showModalForDownload();
            } else {
                console.warn('GatingModal not found, proceeding with download');
                window.location.href = '/data/fire_rankings_national_trends.csv';
            }
        }
        // If gate has been submitted, allow normal download behavior
    };

    return (
        <p className="app-download">
            <a
                className="btn btn-primary"
                href="/data/fire_rankings_national_trends.csv"
                download
                onClick={handleDownloadClick}
            >
                <span className="btn-text">
                    Download this <span className="no-wrap">Trend Data<svg className="btn-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Arrow Right</title><path d="M9.45756 3H6.43911L9.08118 6.72694H6.91882H3V9.28044H6.91882H9.08118L6.43911 13H9.45756L13 8.00369L9.45756 3Z"></path></svg></span>
                </span>
            </a>
        </p>
    );
}

export default DataDownload;
